import { render, staticRenderFns } from "./UpdateDisplayName.vue?vue&type=template&id=c533a404&scoped=true"
import script from "./UpdateDisplayName.vue?vue&type=script&lang=js"
export * from "./UpdateDisplayName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c533a404",
  null
  
)

export default component.exports